export default "__VITE_ASSET__Bpc6qDbs__"